import { getSubdivisions } from '@/locales/supportedLocales.ts';
import i18n from '@/plugins/vue-i18n.js';
import { getActivePinia } from 'pinia';
import { useAccountStore } from '@/store/modules/account/store.js';
import Enum from './Enum.js';

export default class Province extends Enum {
    static get contract() {
        return getActivePinia() ? useAccountStore().contextAccount?.localization : undefined;
    }

    static getProvincesByCountry(country) {
        return getSubdivisions(country, this.contract).map(({ code }) => code);
    }

    static getTranslationKey(country, province) {
        const normalizedProvince = typeof province === 'string' ? province.toUpperCase() : '';
        const definition = getSubdivisions(country, this.contract).find(
            ({ code }) => code.toUpperCase() === normalizedProvince
        );

        return (
            definition?.translation_key ||
            `clientCard.provinces.${String(country || '').toUpperCase()}.${normalizedProvince}`
        );
    }

    static getTranslation(country, province) {
        const normalizedProvince = typeof province === 'string' ? province.toUpperCase() : '';
        const definition = getSubdivisions(country, this.contract).find(
            ({ code }) => code.toUpperCase() === normalizedProvince
        );
        const translationKey = this.getTranslationKey(country, province);

        return i18n.te(translationKey)
            ? i18n.t(translationKey)
            : definition?.name || normalizedProvince;
    }
}
